<template>
  <div :style="logoStyle" v-on:click="onClick" v-on:dblclick="onDblClick">
    <img id="logo" src="../assets/logo.svg" alt="logo" />
    <div id="text" :style="textStyle">
      <div v-if="!oneLine">CODE</div>
      <div v-if="!oneLine">PANDA</div>
      <div v-if="oneLine">CODE PANDA</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {height: String, padding: String, oneLine: Boolean, lightTheme: Boolean},
  data: () => {
    return {
      code: ['dblClick', 'click', 'click', 'dblClick', 'click'],
      codeIndex: 0,
      dblClicking: false,
      manageCodeInProgress: false,
      clickingTimer: undefined,
      clickingTimerHome: undefined,
    }
  },
  computed: {
    logoStyle() {
      let padding = this.padding;
      let paddingTop;
      let paddingRight;
      let paddingBottom;
      let paddingLeft;
      if (!padding) {
        padding = `0`;
      } else {
        const paddingArray = padding.split(',');
        paddingTop = paddingArray[0];
        paddingRight = paddingArray[1];
        paddingBottom = paddingArray[2];
        paddingLeft = paddingArray[3];
        padding = paddingTop + 'px ' +  paddingRight + 'px ' +  paddingBottom + 'px ' +  paddingLeft + 'px';
      }
      return {
        'height': `${this.height}px`,
        'padding': `${padding}`,
        'display': `flex`,
        'justify-content': `center`,
        'align-items': `center`,
        'flex-direction': `row`
      };
    },
    textStyle() {
      let color = this.lightTheme ? '#25BAD0' : '#03252b';
      if (this.oneLine) {
        return {
          'color': color,
          'font-size': `${this.height}px`
        };

      } else {
        let paddingTop;
        let paddingBottom;
        const paddingArray = this.padding.split(',');
        paddingTop = paddingArray[0];
        paddingBottom = paddingArray[2];
        return {
          'color': color,
          'font-size': `${(this.height - paddingTop - paddingBottom) / 2}px`
        };
      }
    }
  },
  methods: {
    onClick: function() {
      clearTimeout(this.clickingTimer);
      clearTimeout(this.clickingTimerHome);
      this.clickingTimer = setTimeout(() => {
        if (!this.dblClicking) {
          this.manageCode('click')        }
        if (!this.dblClicking && !this.manageCodeInProgress && this.$route.path !== '/home') {
          this.$router.push('home');
        }
        this.dblClicking = false;
      }, 200);
    },
    onDblClick: function() {
      this.dblClicking = true;
      this.manageCode('dblClick')
    },
    manageCode: function(trying) {
      if (this.code[this.codeIndex] === trying) {
        this.manageCodeInProgress = true;
        this.codeIndex++;
        if (this.codeIndex === this.code.length) {
          this.$router.push('manage');
        }
      } else {
        this.manageCodeInProgress = false;
        this.codeIndex = 0;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';

  #logo {
    height: 100%;
  }

  /* mobile */
  @media (max-width: 640px) {
    .this-navbar {
      #text {
        color: $mainColor !important;
      }
    }
  }
</style>
